import { InputPreprocessors, PreprocessorParam } from '@cashier/cashier-model';

declare const encryptData: (data: string) => string;

export const PreProcessorConverter = {
  convertInputData: (
    value: string,
    preprocessor: PreprocessorParam,
  ): string => {
    if (typeof encryptData !== 'function') {
      return value;
    }

    let convertedData = '';

    switch (preprocessor.type) {
      case InputPreprocessors.PIQ_ENCRYPTOR:
      case InputPreprocessors.ORCHID_ENCRYPTOR:
        convertedData = encryptData(value.replace(/\s/g, ''));
        break;
    }

    return convertedData || value;
  },
};
